module.exports = __webpack_public_path__ + "static/media/anatomia.e86dd198.png";